import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const LawyerIcon = ({ width = 24, height = 24, color = colors.grey[50] }: IProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <g clipPath='url(#clip0_10004_5294)'>
                <path
                    d='M12.0004 2.3999C8.60839 2.3999 7.20039 4.5759 7.20039 7.1999C7.20039 8.0879 7.62383 8.97646 7.62383 8.97646C7.45583 9.07246 7.17702 9.38403 7.24102 9.92803C7.37702 10.96 7.81708 11.2165 8.10508 11.2405C8.20908 12.1925 9.24039 13.4239 9.60039 13.5999V15.1999C9.59864 15.2052 9.59439 15.2087 9.59258 15.214C9.32802 15.2468 9.09199 15.4029 8.97227 15.6452L8.72227 16.1483C6.74782 17.2554 2.40039 16.9809 2.40039 21.5999H11.2004V16.7999C11.2004 15.4799 12.2804 14.3999 13.6004 14.3999H14.4004V13.5999C14.7604 13.4239 15.7917 12.1925 15.8957 11.2405C16.1837 11.2165 16.6238 10.96 16.7598 9.92803C16.8238 9.37603 16.545 9.07246 16.377 8.97646C16.377 8.97646 16.8004 8.1679 16.8004 7.1999C16.8004 5.2559 16.0404 3.5999 14.4004 3.5999C14.4004 3.5999 13.8324 2.3999 12.0004 2.3999ZM17.6004 14.3999C16.7164 14.3999 16.0004 15.1159 16.0004 15.9999H13.6004C13.1604 15.9999 12.8004 16.3599 12.8004 16.7999V19.9999C12.8004 20.4399 13.1604 20.7999 13.6004 20.7999H16.8004C16.8004 20.3599 17.1604 19.9999 17.6004 19.9999H19.2004C19.6404 19.9999 20.0004 20.3599 20.0004 20.7999H23.2004C23.6404 20.7999 24.0004 20.4399 24.0004 19.9999V16.7999C24.0004 16.3599 23.6404 15.9999 23.2004 15.9999H20.8004C20.8004 15.1159 20.0844 14.3999 19.2004 14.3999H17.6004ZM12.8004 22.2562V23.1999C12.8004 23.6399 13.1604 23.9999 13.6004 23.9999H23.2004C23.6404 23.9999 24.0004 23.6399 24.0004 23.1999V22.2562C23.7524 22.3522 23.4804 22.3999 23.2004 22.3999H13.6004C13.3204 22.3999 13.0484 22.3522 12.8004 22.2562Z'
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id='clip0_10004_5294'>
                    <rect width='24' height='24' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export default React.memo(LawyerIcon)
